import { JourneyCanvasState } from '../utility/TypeDefs';
import { Actions, UpdateActions } from './TypeDefs';

import {
  cancelCompensatoryEventMap, cancelStepDesign, cemSaveBtnEnable, changeConditionText, clickInitiateStepCard, clickStepCard, clickStepConnectorIcon, closeJourneyStepModal, closePayloadTransformModal, closeSchedulerModal, condExpSave, connectorDraw, createFlowItem, deleteCompensatoryEventMap, deleteConnector,
  deleteFlowItem, deleteStepItem, deleteSubsequentSteps, designCompensatoryEventMap, dismissStepCardMenuDropdown, draggingItem, editStepDetails, externalEventConfirmationSave, fetchAllAssociatedServices, fetchAllServicesAndJourneyData, fetchServiceOperations, flowBuilderSize, flowItemDragComplete, hideApiError, hideCondExpModal, hideDeleteNotifyDialog, hideExternalEventConfirmationModal, hideExternalOnSubsequentStepModal, hideSidebar,
  loadCompensatoryEventMap, loadJourneyMetadata, loadMoreServices, moreServicesLoadFailed, moreServicesLoaded, noneSelected, notifyApiError, notifyDeleteCem, notifyDeleteConnector, notifyDeleteNode, notifyDeleteStep, openPayloadTransformModal, openSchedulerModal, openSidebarAfterServiceReturn, pickIngressEvent, pickService, replaceAllServicesList, restoreParentJourney,
  saveCompensatoryEventMap, saveJourneyBtnEnable, saveJourneySuccess, searchItems, selectConnector, selectFlowItem, selectStart,
  setEventSchema, clearEventSchema,
  setJourneyStepDetails, setPayloadForConvergingServices, setSearchData, setSideBarForCommentHistory, setSidebarInvalidSearch, setStepCardMenuCoordinates, setViewJourneyInitiatedFlag, showCondExpModal,
  showExternalEventConfirmationModal,
  showSaveJourneyModal, sidebarDataError, sidebarDataLoading, storeStepJourney
} from './reducer-actions';
/**
 * @method reducer
 * @description calls specific functions based on actions
 * @param state Journey canvas state
 * @param action Updates actions
 * @returns updated state
 */
export const reducer = (state: JourneyCanvasState, action: UpdateActions): JourneyCanvasState => {
  // sonar: maximum non-empty cases in switch is 30
  switch (action.type) {
    case Actions.FETCH_ALL_SERVICES_AND_JOURNEY_DATA: return fetchAllServicesAndJourneyData(state, action.payload);
    case Actions.FETCH_ALL_ASSOCIATED_SERVICES: return fetchAllAssociatedServices(state, action.payload);
    case Actions.SELECT_CONNECTOR: return selectConnector(state, action.payload);
    case Actions.FLOW_BUILDER_SIZE: return flowBuilderSize(state, action.payload);
    case Actions.SELECT_FLOW_ITEM: return selectFlowItem(state, action.payload);
    case Actions.NONE_SELECTED: return noneSelected(state);
    case Actions.CONNECTOR_DRAW: return connectorDraw(state, action.payload);
    case Actions.DELETE_FLOW_ITEM: return deleteFlowItem(state, action.payload);
    case Actions.DELETE_CONNECTOR: return deleteConnector(state);
    case Actions.FLOW_ITEM_DRAG_COMPLETE: return flowItemDragComplete(state, action.payload);
    case Actions.SET_SEARCH_DATA: return setSearchData(state, action.payload);
    case Actions.SEARCH_ITEMS: return searchItems(state, action.payload);
    case Actions.REPLACE_ALL_SERVICES_LIST: return replaceAllServicesList(state, action.payload);
    case Actions.PICK_SERVICE: return pickService(state, action.payload);
    case Actions.CREATE_FLOW_ITEM: return createFlowItem(state, action.payload);
    case Actions.DRAGGING_ITEM: return draggingItem(state, action.payload);
    case Actions.SAVE_JOURNEY_BTN_ENABLE: return saveJourneyBtnEnable(state, action.payload);
    case Actions.SELECT_START: return selectStart(state);
    case Actions.PICK_INGRESS_EVENT: return pickIngressEvent(state, action.payload);
    case Actions.HIDE_SIDEBAR: return hideSidebar(state);
    case Actions.OPEN_SIDEBAR_AFTER_SERVICE_RETURN: return openSidebarAfterServiceReturn(state, action.payload);
    case Actions.SIDEBAR_DATA_LOADING: return sidebarDataLoading(state);
    case Actions.SIDEBAR_DATA_ERROR: return sidebarDataError(state);
    case Actions.LOAD_JOURNEY_METADATA: return loadJourneyMetadata(state, action.payload);
    case Actions.LOAD_MORE_SERVICES: return loadMoreServices(state);
    case Actions.MORE_SERVICES_LOADED: return moreServicesLoaded(state, action.payload);
    case Actions.MORE_SERVICES_LOAD_FAILED: return moreServicesLoadFailed(state);
    case Actions.SAVE_JOURNEY_SUCCESS: return saveJourneySuccess(state, action.payload);
    case Actions.FETCH_SERVICE_OPERATIONS: return fetchServiceOperations(state, action.payload);
    case Actions.DESIGN_COMPENSATORY_EVENT_MAP: return designCompensatoryEventMap(state, action.payload);
    case Actions.LOAD_COMPENSATORY_EVENT_MAP: return loadCompensatoryEventMap(state);
    case Actions.CANCEL_COMPENSATORY_EVENT_MAP: return cancelCompensatoryEventMap(state);
    case Actions.SET_EVENT_SCHEMA: return setEventSchema(state, action.payload);
    case Actions.CLEAR_EVENT_SCHEMA: return clearEventSchema(state);
    default: break;
  }

  switch (action.type) {
    case Actions.SAVE_COMPENSATORY_EVENT_MAP: return saveCompensatoryEventMap(state, action.payload);
    case Actions.RESTORE_PARENT_JOURNEY: return restoreParentJourney(state);
    case Actions.DELETE_COMPENSATORY_EVENT_MAP: return deleteCompensatoryEventMap(state);
    case Actions.HIDE_DELETE_NOTIFY_DIALOG: return hideDeleteNotifyDialog(state);
    case Actions.NOTIFY_DELETE_NODE: return notifyDeleteNode(state, action.payload);
    case Actions.NOTIFY_DELETE_CEM: return notifyDeleteCem(state, action.payload);
    case Actions.NOTIFY_DELETE_CONNECTOR: return notifyDeleteConnector(state, action.payload);
    case Actions.CHANGE_CONDITION_TEXT: return changeConditionText(state, action.payload);
    case Actions.CLOSE_JOURNEY_STEP_MODAL: return closeJourneyStepModal(state);
    case Actions.NOTIFY_API_ERROR: return notifyApiError(state);
    case Actions.CLICK_STEP_CARD: return clickStepCard(state, action.payload);
    case Actions.SET_JOURNEY_STEP_DETAILS: return setJourneyStepDetails(state, action.payload);
    case Actions.CANCEL_STEP_DESIGN: return cancelStepDesign(state);
    case Actions.STORE_STEP_JOURNEY: return storeStepJourney(state);
    case Actions.DISMISS_STEP_CARD_MENU_DROPDOWN: return dismissStepCardMenuDropdown(state);
    case Actions.OPEN_SCHEDULER_MODAL: return openSchedulerModal(state);
    case Actions.CLOSE_SCHEDULER_MODAL: return closeSchedulerModal(state);
    case Actions.DELETE_SUBSEQUENT_STEPS: return deleteSubsequentSteps(state, action.payload);
    case Actions.SET_STEP_CARD_MENU_COORDINATES: return setStepCardMenuCoordinates(state, action.payload);
    case Actions.NOTIFY_DELETE_STEP: return notifyDeleteStep(state);
    case Actions.DELETE_STEP_ITEM: return deleteStepItem(state, action.payload);
    case Actions.CLICK_STEP_CONNECTOR_ICON: return clickStepConnectorIcon(state, action.payload);
    case Actions.CLICK_INITIATE_STEP_CARD: return clickInitiateStepCard(state);
    case Actions.HIDE_API_ERROR: return hideApiError(state);
    case Actions.VIEW_JOURNEY_INITIATED: return setViewJourneyInitiatedFlag(state, action.payload);
    case Actions.OPEN_PAYLOAD_TRANSFORM_MODAL: return openPayloadTransformModal(state, action.payload);
    case Actions.CLOSE_PAYLOAD_TRANSFORM_MODAL: return closePayloadTransformModal(state);
    case Actions.SET_PAYLOAD_FOR_CONVERGING_SERVICES: return setPayloadForConvergingServices(state, action.payload);
    case Actions.SHOW_SAVE_JOURNEY_MODAL: return showSaveJourneyModal(state);
    case Actions.COND_EXP_SAVE: return condExpSave(state, action.payload);
    default: break;
  }

  switch (action.type) {
    case Actions.SET_SIDEBAR_INVALID_SEARCH: return setSidebarInvalidSearch(state);
    case Actions.CEM_SAVE_BTN_ENABLE: return cemSaveBtnEnable(state, action.payload);
    case Actions.SHOW_COND_EXP_MODAL: return showCondExpModal(state, action.payload);
    case Actions.HIDE_COND_EXP_MODAL: return hideCondExpModal(state);
    case Actions.SET_SIDEBAR_FOR_COMMENT_HISTORY: return setSideBarForCommentHistory(state);
    case Actions.HIDE_EXTERNAL_ON_SUBSEQUENT_STEP: return hideExternalOnSubsequentStepModal(state);
    case Actions.EDIT_STEP_DETAILS: return editStepDetails(state);
    case Actions.SHOW_EXTERNAL_EVENT_CONFIRMATION_MODAL: return showExternalEventConfirmationModal(state, action.payload);
    case Actions.HIDE_EXTERNAL_EVENT_CONFIRMATION_MODAL: return hideExternalEventConfirmationModal(state);
    case Actions.EXTERNAL_EVENT_CONFIRMATION_SAVE: return externalEventConfirmationSave(state, action.payload);
    default: break;
  }
  return state;
};
